import $ from 'jquery';
import { CustomerApi, ContractApi } from '../api/apicollection';

export default function CustomerContractsViewModel() {
    this.customerId = document.getElementById('CustomerId').value;
    this.centralCustomerId = document.getElementById('CentralCustomerId').value;

    this.customer = ko.observable();
    this.contracts = ko.observableArray([]);

    this.fullName = ko.pureComputed(() => {
        return (this.customer() === undefined)
            ? '' : `${this.customer().firstName} ${this.customer().lastName}`;
    }, this);

    this.TakePayment = function (contract) {
        window.location.replace(`/payment/${contract.contractNumber}/${contract.contractId}/${contract.customerId}/${contract.centralCustomerId}`)
    };

    this.Load = () => {
        CustomerApi.getCustomerInfo(this.customerId).then(data => {
            $('#loadingSpinner').hide();
            this.customer(data.data);
        });

        ContractApi.getCustomerContracts(this.customerId, this.centralCustomerId).then(data => {
            this.contracts(data.data);
        });
    };
    this.Load();

    return this;
};